<div>
    <div *ngFor="let column of columns">
      <label>
        <input type="checkbox" (change)="toggleColumn(column)" [checked]="!visibleColumns[column]">
        {{ column }}
      </label>
    </div>
  </div>  